const Routes = require('./constants/routes.json');

module.exports = Routes;

